import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Banner, FooterAPIResponse } from '../models/banner.model';
import { getBannerAndBrandImageUrl, getFooterUrl } from '../../../constants/url-constants';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BannerService {
  constructor(private httpClient: HttpClient) {}

  getAllBannersAndBrandImage(clientName) {
    return this.httpClient.get<Banner[]>(getBannerAndBrandImageUrl+'/'+clientName);
    //return this.httpClient.get<Banner[]>(getBannerAndBrandImageUrl);
  }

  getFooter$ = this.httpClient
    .get<FooterAPIResponse>(getFooterUrl)
    .pipe(map((response) => response.data));
}
